export const visit = (vm, at) => {
vm(require("credit-memos-ui-lib/lang/en.lyaml"));
at({ "en": { "creditMemosHighlightCard": { "propertyLabels": { "status": "Status:" } } } });
};